import { render, staticRenderFns } from "./ExamSessionsWidget.vue?vue&type=template&id=5df7ec40"
import script from "./ExamSessionsWidget.vue?vue&type=script&lang=js"
export * from "./ExamSessionsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports